var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0615 5.06097V1.31372H4.8662C4.19345 1.31372 3.64795 1.85947 3.64795 2.53222V22.5952C3.64795 23.268 4.19345 23.8137 4.8662 23.8137H19.8089C20.4817 23.8137 21.0272 23.268 21.0272 22.5952V6.27947H17.2802C16.6075 6.27947 16.0615 5.73397 16.0615 5.06097Z",
    fill: "#0074B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0615 5.06097C16.0615 5.73372 16.6075 6.27947 17.2803 6.27947H21.0273L16.0615 1.31372V5.06097Z",
    fill: "#98C7E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M16.0615 5.06097C16.0615 5.73372 16.6075 6.27947 17.2803 6.27947H21.0273L16.0615 1.31372V5.06097Z",
    fill: "#98C7E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79562 14.7233C6.48553 14.7233 6.26904 14.9456 6.26904 15.2674C6.26904 15.5778 6.48553 15.806 6.78392 15.806H6.78977C7.10605 15.806 7.31668 15.5778 7.31668 15.2674C7.3105 14.9397 7.10019 14.7233 6.79562 14.7233Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95089 12.4641C10.2727 12.4641 10.5246 12.5343 10.7001 12.6104L10.8874 11.9083C10.7294 11.8264 10.3783 11.7324 9.91578 11.7324C8.72188 11.7324 7.76233 12.4758 7.76233 13.8218C7.76233 14.9517 8.46444 15.8059 9.82802 15.8059C10.3019 15.8059 10.6764 15.7123 10.8347 15.6363L10.706 14.9342C10.5243 15.0102 10.2317 15.0629 9.95674 15.0629C9.16622 15.0629 8.69847 14.5656 8.69847 13.7754C8.69847 12.8915 9.24813 12.4641 9.95089 12.4641Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0168 13.4006C12.502 13.2016 12.2855 13.0905 12.2855 12.8386C12.2855 12.6396 12.4727 12.4579 12.8589 12.4579C13.2395 12.4579 13.5262 12.5694 13.6783 12.6452L13.8772 11.9314C13.6432 11.8202 13.3211 11.7324 12.8706 11.7324C11.9455 11.7324 11.3779 12.2414 11.3779 12.9146C11.3779 13.4942 11.8109 13.8569 12.4669 14.091C12.9408 14.2551 13.128 14.4014 13.128 14.6413C13.128 14.9049 12.9112 15.0743 12.5016 15.0743C12.1213 15.0743 11.7469 14.9514 11.5125 14.8285L11.3308 15.5599C11.5535 15.6831 11.9981 15.8059 12.4487 15.8059C13.5314 15.8059 14.0346 15.2439 14.0346 14.5828C14.0352 14.0211 13.7134 13.658 13.0168 13.4006Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5477 13.4825C16.4131 13.9333 16.2899 14.4014 16.1905 14.8753H16.1729C16.079 14.3835 15.9564 13.9388 15.8219 13.4649L15.3418 11.7968H14.364L15.6285 15.7416H16.6702L17.9987 11.7968H17.0505L16.5477 13.4825Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvLogo);
export default __webpack_public_path__ + "static/media/csv-logo.f8088359b4b13b9a3364188cafcde673.svg";
export { ForwardRef as ReactComponent };